export const overlaybadge = {
  root: {
    outline: {
      width: "0",
      color: "{content.background}",
    },
  },
};
